import { render } from "./CreatorsWidget.vue?vue&type=template&id=c9811638&scoped=true"
import script from "./CreatorsWidget.vue?vue&type=script&lang=js"
export * from "./CreatorsWidget.vue?vue&type=script&lang=js"

import "./CreatorsWidget.vue?vue&type=style&index=0&id=c9811638&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9811638"]])

export default __exports__